import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    label: "TAG",
    multiple:true,
    data: null,
    doApply: null,
    SearchPanel: false,
    zindex:1300
};

const tagsearchSlice = createSlice({
    name: 'tagsearch',
    initialState,
    reducers: {
        tagsearchopen: (state, action) => {
            return Object.assign({}, state, {
                open: true, 
                data: action.payload.data, 
                doApply: action.payload.doApply,
                SearchPanel: action.payload.SearchPanel,
                zindex: action.payload.zindex
            })
        },
        tagsearchclose: (state, action) => {
            return initialState
        }
    },
});

export const {
    tagsearchopen, tagsearchclose
} = tagsearchSlice.actions

export default tagsearchSlice;

